// Simple pub/sub utility to replace dojo/topic
const subscribers = {};

function subscribe(event, handler) {
  if (!subscribers[event]) {
    subscribers[event] = [];
  }
  subscribers[event].push(handler);
  return {
    remove: function () {
      subscribers[event] = subscribers[event].filter(function (h) { return h !== handler; });
    }
  };
}

function publish(event) {
  var args = Array.prototype.slice.call(arguments, 1);
  if (subscribers[event]) {
    subscribers[event].forEach(function (handler) {
      handler.apply(null, args);
    });
  }
}

const pubSub = { subscribe: subscribe, publish: publish };

export default pubSub;
